module.exports = __webpack_public_path__ + "img/reloading-screen.b0af81d1.svg";